import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import SelectList from './SelectList';

const services = [
  {
    value: 1,
    label: 'Application for Issuance of a Certificate of Public Convinience'
  }
]

const ServiceOptions = ({ onSelect }) => {
  const handleSelect = selected => {
    onSelect(selected)
  }
  return (
    <div className="flex flex-col">
      <div className="inline-flex space-x-2 items-center justify-center">
        <Icon.Transaction className="!text-primary"/>
        <b className="text-lg xl:text-3xl lg:text-2xl">Select Transaction</b>
      </div>
      <div className="flex my-10">
        <SelectList data={services} onSelect={handleSelect}/>
      </div>
    </div>
  )
}

ServiceOptions.defaultProps = {
  onSelect: () => {}
}

ServiceOptions.propTypes = {
  onSelect: PropTypes.instanceOf(Function)
}

export default ServiceOptions